export default {
    namespaced: true,
    state: {
        saleId: null,
        ruSEO: {},
        wwSEO: {},
        ruPPC: {},
        wwPPC: {},
        ruMinus: null,
        wwMinus: null,

        ruSEOUpdated: null,
        wwSEOUpdated: null,
        ruPPCUpdated: null,
        wwPPCUpdated: null,

        isSendingSAVE_RU_MINUS: false,
        isSendingSAVE_WW_MINUS: false,
        timerSAVE_RU_MINUS: null,
        timerSAVE_WW_MINUS: null,

        isSendingSAVE_RU_SEO: false,
        isSendingSAVE_WW_SEO: false,
        timerSAVE_RU_SEO: null,
        timerSAVE_WW_SEO: null,

        isSendingSAVE_RU_PPC: false,
        isSendingSAVE_WW_PPC: false,
        timerSAVE_RU_PPC: null,
        timerSAVE_WW_PPC: null,

        isFrequencyUpdate: false,
        isSendAlready: false,

        currentBrand: null,
    },
    getters: {
        CURRENT_BRAND: state => {
            return state.currentBrand;
        },
        RU_SEO_UPDATED: state => {
            return state.ruSEOUpdated;
        },
        WW_SEO_UPDATED: state => {
            return state.wwSEOUpdated;
        },
        RU_PPC_UPDATED: state => {
            return state.ruPPCUpdated;
        },
        WW_PPC_UPDATED: state => {
            return state.wwPPCUpdated;
        },
        IS_SEND_ALREADY: state => {
            return state.isSendAlready;
        },
        SALE_ID: state => {
            return state.saleId;
        },
        RU_SEO: state => {
            return state.ruSEO;
        },
        WW_SEO: state => {
            return state.wwSEO;
        },
        RU_PPC: state => {
            return state.ruPPC;
        },
        WW_PPC: state => {
            return state.wwPPC;
        },
        RU_MINUS: state => {
            return state.ruMinus;
        },
        WW_MINUS: state => {
            return state.wwMinus;
        }
    },
    mutations: {
        CURRENT_BRAND: (state, payload) => {
            return state.currentBrand = payload;
        },
        RU_SEO_UPDATED: (state, payload) => {
            return state.ruSEOUpdated = payload;
        },
        WW_SEO_UPDATED: (state, payload) => {
            return state.wwSEOUpdated = payload;
        },
        RU_PPC_UPDATED: (state, payload) => {
            return state.ruPPCUpdated = payload;
        },
        WW_PPC_UPDATED: (state, payload) => {
            return state.wwPPCUpdated = payload;
        },
        SALE_ID: (state, payload) => {
            return state.saleId = payload;
        },
        RU_SEO: (state, payload) => {
            return state.ruSEO = payload;
        },
        WW_SEO: (state, payload) => {
            return state.wwSEO = payload;
        },
        RU_PPC: (state, payload) => {
            return state.ruPPC = payload;
        },
        WW_PPC: (state, payload) => {
            return state.wwPPC = payload;
        },
        RU_MINUS: (state, payload) => {
            return state.ruMinus = payload;
        },
        WW_MINUS: (state, payload) => {
            return state.wwMinus = payload;
        }
    },
    actions: {
        GET_SEMANTICS: async ({state, commit}, payload) => {
            payload.th.showOverlay++;
            // set null for rewrite vue component
            state.currentBrand = null
            payload.th.$forceUpdate()
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand-semantics/' + payload.id,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('RU_SEO', responseData.data.ruSEO.length == 0 ? {} : responseData.data.ruSEO);
                    commit('WW_SEO', responseData.data.wwSEO.length == 0 ? {} : responseData.data.wwSEO);
                    commit('RU_PPC', responseData.data.ruPPC.length == 0 ? {} : responseData.data.ruPPC);
                    commit('WW_PPC', responseData.data.wwPPC.length == 0 ? {} : responseData.data.wwPPC);
                    commit('RU_MINUS', responseData.data.ruMinus);
                    commit('WW_MINUS', responseData.data.wwMinus);

                    commit('RU_SEO_UPDATED', responseData.data.ruSEOUpdated);
                    commit('RU_PPC_UPDATED', responseData.data.ruPPCUpdated);
                    commit('WW_SEO_UPDATED', responseData.data.wwSEOUpdated);
                    commit('WW_PPC_UPDATED', responseData.data.wwPPCUpdated);

                    payload.th.ruMinus = responseData.data.ruMinus;
                    payload.th.wwMinus = responseData.data.wwMinus;
                    state.isSendAlready = payload.id;

                    state.currentBrand = responseData.brand
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        SAVE_RU_SEO: async ({state, commit, dispatch}, payload) => {
            if (state.isSendingSAVE_RU_SEO) {
                if (state.timerSAVE_RU_SEO != null) {
                    clearTimeout(state.timerSAVE_RU_SEO);
                }
                state.timerSAVE_RU_SEO = setTimeout(() => {
                    state.timerSAVE_RU_SEO = null;
                    dispatch('SAVE_RU_SEO', {th: payload.th});
                }, 2000);
            } else {
                state.isSendingSAVE_RU_SEO = true;
                await payload.th.$store.dispatch('SEND_POST', {
                    url: '/brand-semantics/seo/ru/' + state.saleId,
                    parameter: state.ruSEO,
                    th: payload.th,
                    showSuccessMessage: false,
                    getSuccessResponse: (responseData) => {
                        commit('RU_SEO', responseData.data);
                    },
                    getResponse: () => {
                        state.isSendingSAVE_RU_SEO = false;
                    }
                });
            }
        },
        SAVE_WW_SEO: async ({state, commit, dispatch}, payload) => {
            if (state.isSendingSAVE_WW_SEO) {
                if (state.timerSAVE_WW_SEO != null) {
                    clearTimeout(state.timerSAVE_WW_SEO);
                }
                state.timerSAVE_WW_SEO = setTimeout(() => {
                    state.timerSAVE_WW_SEO = null;
                    dispatch('SAVE_WW_SEO', {th: payload.th});
                }, 2000);
            } else {
                state.isSendingSAVE_WW_SEO = true;
                await payload.th.$store.dispatch('SEND_POST', {
                    url: '/brand-semantics/seo/ww/' + state.saleId,
                    parameter: state.wwSEO,
                    th: payload.th,
                    showSuccessMessage: false,
                    getSuccessResponse: (responseData) => {
                        commit('WW_SEO', responseData.data);
                    },
                    getResponse: () => {
                        state.isSendingSAVE_WW_SEO = false;
                    }
                });
            }
        },
        SAVE_RU_PPC: async ({state, commit, dispatch}, payload) => {
            if (state.isSendingSAVE_RU_PPC) {
                if (state.timerSAVE_RU_PPC != null) {
                    clearTimeout(state.timerSAVE_RU_PPC);
                }
                state.timerSAVE_RU_PPC = setTimeout(() => {
                    state.timerSAVE_RU_PPC = null;
                    dispatch('SAVE_RU_PPC', {th: payload.th});
                }, 2000);
            } else {
                state.isSendingSAVE_RU_PPC = true;
                await payload.th.$store.dispatch('SEND_POST', {
                    url: '/brand-semantics/ppc/ru/' + state.saleId,
                    parameter: state.ruPPC,
                    th: payload.th,
                    showSuccessMessage: false,
                    getSuccessResponse: (responseData) => {
                        commit('RU_PPC', responseData.data);
                    },
                    getResponse: () => {
                        state.isSendingSAVE_RU_PPC = false;
                    }
                });
            }
        },
        SAVE_WW_PPC: async ({state, commit, dispatch}, payload) => {
            if (state.isSendingSAVE_WW_PPC) {
                if (state.timerSAVE_WW_PPC != null) {
                    clearTimeout(state.timerSAVE_WW_PPC);
                }
                state.timerSAVE_WW_PPC = setTimeout(() => {
                    state.timerSAVE_WW_PPC = null;
                    dispatch('SAVE_WW_PPC', {th: payload.th});
                }, 2000);
            } else {
                state.isSendingSAVE_WW_PPC = true;
                await payload.th.$store.dispatch('SEND_POST', {
                    url: '/brand-semantics/ppc/ww/' + state.saleId,
                    parameter: state.wwPPC,
                    th: payload.th,
                    showSuccessMessage: false,
                    getSuccessResponse: (responseData) => {
                        commit('WW_PPC', responseData.data);
                    },
                    getResponse: () => {
                        state.isSendingSAVE_WW_PPC = false;
                    }
                });
            }
        },
        SAVE_RU_MINUS: async ({state, dispatch}, payload) => {
            if (state.isSendingSAVE_RU_MINUS) {
                if (state.timerSAVE_RU_MINUS != null) {
                    clearTimeout(state.timerSAVE_RU_MINUS);
                }
                state.timerSAVE_RU_MINUS = setTimeout(() => {
                    state.timerSAVE_RU_MINUS = null;
                    dispatch('SAVE_RU_MINUS', {th: payload.th});
                }, 2000);

            } else {
                state.isSendingSAVE_RU_MINUS = true;
                await payload.th.$store.dispatch('SEND_POST', {
                    url: '/brand-semantics/minus/ru/' + state.saleId,
                    parameter: state.ruMinus,
                    th: payload.th,
                    showSuccessMessage: false,
                    getResponse: () => {
                        state.isSendingSAVE_RU_MINUS = false;
                    }
                });
            }
        },
        SAVE_WW_MINUS: async ({state, dispatch}, payload) => {
            if (state.isSendingSAVE_WW_MINUS) {
                if (state.timerSAVE_WW_MINUS != null) {
                    clearTimeout(state.timerSAVE_WW_MINUS);
                }
                state.timerSAVE_WW_MINUS = setTimeout(() => {
                    state.timerSAVE_WW_MINUS = null;
                    dispatch('SAVE_WW_MINUS', {th: payload.th});
                }, 2000);
            } else {
                state.isSendingSAVE_WW_MINUS = true;
                await payload.th.$store.dispatch('SEND_POST', {
                    url: '/brand-semantics/minus/ww/' + state.saleId,
                    parameter: state.wwMinus,
                    th: payload.th,
                    showSuccessMessage: false,
                    getResponse: () => {
                        state.isSendingSAVE_WW_MINUS = false;
                    }
                });
            }
        },
        FREQUENCY_UPDATE: async ({state, commit}, payload) => {
            if (state.isFrequencyUpdate) {
                return false;
            }
            state.isFrequencyUpdate = true;
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand-semantics/frequency-update/' + payload.type + '/' + state.saleId,
                parameter: state.wwPPC,
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: (responseData) => {
                    switch (payload.type) {
                        case 'ruSEO':
                            commit('RU_SEO', responseData.data);
                            commit('RU_SEO_UPDATED', responseData.date);
                            break;
                        case 'ruPPC':
                            commit('RU_PPC', responseData.data);
                            commit('RU_PPC_UPDATED', responseData.date);
                            break;
                        case 'wwSEO':
                            commit('WW_SEO', responseData.data);
                            commit('WW_SEO_UPDATED', responseData.date);
                            break;
                        case 'wwPPC':
                            commit('WW_PPC', responseData.data);
                            commit('RU_PPC_UPDATED', responseData.date);
                            break;
                    }
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                    state.isFrequencyUpdate = false;
                }
            });
        },
    }
}